import Vue from "vue";
import Component from "vue-class-component";
import common from "../../common";
import config_ from "../config";


const config = require("../config") as typeof config_;

declare function require(module: string): unknown;

//const jsUtilities = require("../../js/jsUtilities") as any;
//const jsClasses = require("../../js/jsClasses") as any;


// The @Component decorator indicates the class is a Vue component
@Component
class MessagesManagerVue extends Vue {

    items = [] as common.IMessagesManagerItem[];

    $initialData: any;
    private _rootId?: string;
    private _onClickItemCallback = null as ((messageId: string, messageType?: common.MessageTypes, url?: string, asBlank?: boolean) => void) | null;
    private _onClickItemLinkCallback = null as ((messageId: string, messageType?: common.MessageTypes, url?: string, asBlank?: boolean) => void) | null;

    beforeCreate() {
        this._rootId = this.$initialData.vueElId;
        this.$options.el = '#' + this._rootId;
    }

    created() {
    }

    mounted() {
    }

    setOnClickItemCallback(callback: (messageId: string, messageType?: common.MessageTypes, clickUrl?: string, asBlank?: boolean) => void) {
        if (callback)
            this._onClickItemCallback = callback;

        return this;
    }

    setOnClickItemLinkCallback(callback: (messageId: string, messageType?: common.MessageTypes, linkUrl?: string, asBlank?: boolean) => void) {
        if (callback)
            this._onClickItemLinkCallback = callback;

        return this;
    }

    onClickItem(event: Event, messageId: string, messageType?: common.MessageTypes, clickUrl?: string, asBlank?: boolean, noCloseOnClick?: boolean) {

        if (noCloseOnClick === true)
            return;

        event.stopPropagation();
        event.preventDefault();

        if (this._onClickItemCallback)
            this._onClickItemCallback(messageId, messageType, clickUrl, asBlank);

        this.closeItemById(messageId);
    }

    onClickItemLink(event: Event, messageId: string, messageType?: common.MessageTypes, url?: string, asBlank?: boolean) {
        if (!url)
            return;

        if (this._onClickItemLinkCallback)
            this._onClickItemLinkCallback(messageId, messageType, url, asBlank);

        this.closeItemById(messageId);
    }

    onClickItemCloser(event: Event, messageId: string) {
        event.stopPropagation();
        event.preventDefault();
        this.closeItemById(messageId);
    }

    isRealLink(url?: string, messageType?: common.MessageTypes) {
        if (!url)
            return false;

        if (messageType === common.MessageTypes.notification)
            return false;// attendre le URL en provenance de l'API

        return true;
    }

    append(message: common.IMessagesManagerItem) {

        if (message.durationMs) {
            const id = message.id;
            const f = () => {
                this.closeItemById(id);
            };

            setTimeout(f, message.durationMs);
        }

        this.items.unshift(message);//ajouter en debut de pile
    }

    closeAll() {
        this.items = [];
        return this;
    }

    closeBySource(source?: string | null) {
        const ids = this.getMessageIdsBySource(source);
        this.removeMessageByIds(ids);
    }

    getMessageIdsBySource(source?: string | null) {
        const messages = this.getMessagesBySource(source);
        const ids = [] as string[];
        for (let i = 0; i < messages.length; i++) {
            const message = messages[i];
            if (message && message.id)
                ids.push(message.id);
        }

        return ids;
    }

    getMessagesBySource(source?: string | null) {
        if (!source)
            return [];

        const items = [] as common.IMessagesManagerItem[];
        this.forEarchItems(x => {
            if (x.messageSource === source)
                items.push(x);
        });

        return items;
    }

    getMessageById(messageId: string) {
        if (!messageId)
            throw "L'argument 'messageId' est requis.";

        const item = this.forEarchItems(x => {
            if (x.id === messageId)
                return x;
        });

        return item as common.IMessagesManagerItem;
    }

    closeItemById(messageId?: string | null) {
        if (!messageId)
            throw "L'argument 'messageId' est requis.";

        const el = document.getElementById(messageId)

        if (el)
            el.setAttribute("messages-manager-item-state", "closing");

        const f = () => {
            this.removeMessageById(messageId);
        };

        setTimeout(f, config.messages.closingDurationMs);
    }

    private removeMessageById(messageId: string) {
        if (!messageId)
            throw "L'argument 'messageId' est requis.";
        this.items = this.items.filter(x =>
            x.id !== messageId);
    }

    private removeMessageByIds(messageIds: string[]) {
        if (!messageIds || !messageIds.length)
            return;

        this.items = this.items.filter(x => {
            for (let i = 0; i < messageIds.length; i++) {
                const id = messageIds[i];
                if (id === x.id)
                    return false;
            }

            return true;
        });
    }

    private forEarchItems(action: (m: common.IMessagesManagerItem) => any) {
        if (action)
            if (this.items) for (let i = 0; i < this.items.length; i++) {
                const x = this.items[i];
                const r = action(x);
                if (r || r === 0 || r === '')
                    return r;
            }

        return null;
    }
}

export = MessagesManagerVue;